import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

export const getPunishmentConfig = () => {
  const url = getAgpApiUrl('riskcase_service/accountPunish/api', 'getConfigData');
  return smb_fetch(url, {
    method: 'GET',
    data: {},
    isCache: true,
  }, false, false);
};

// 获取列表数据
export const getPunishmentSearch = (data: any) => {
  const url = getAgpApiUrl('riskcase_service/accountPunish/api', 'list');
  return smb_fetch(url, {
    method: 'POST',
    isCancel: true,
    ...data,
  }, true, false).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.page_conf?.total_num || 0,
        },
      },
    };
  });
};


export default {
  getPunishmentSearch,
};
